module.exports = "\r\n\r\ntable >thead >tr >th{\r\n    text-align:center !important;\r\n}\r\n\r\na.disabled {\r\n  pointer-events: none;\r\n  cursor: default;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/management/journal-list/journal-list.component.css
// module id = ./src/app/components/management/journal-list/journal-list.component.css
// module chunks = main